/** Tiny dependency-free className joiner for the v2 dashboard tree. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
